<template>
  <div id="boxes-modal">
    <div class="labels-wrapper" ref="labels-wrapper">
      <div
        class="label"
        v-for="(item, index) in tabs"
        :key="index"
        @click="changeTab(index)"
        :class="{ active: activeTabIndex === index }"
      >
        {{ item.label }}
      </div>
    </div>
    <div class="component-wrapper" ref="component-wrapper">
      <transition name="fade" mode="out-in">
        <component
          :is="activeTab.component.bind.is"
          v-bind="activeTab.component.bind"
          v-on="activeTab.component.on"
        ></component>
      </transition>
    </div>
  </div>
</template>

<script>
import GenerateBoxes from "./GenerateBoxes";
import BoxModal from "./BoxModal";
export default {
  name: "BoxesModal",
  data() {
    return {
      activeTabIndex: 0,
      activeTab: undefined
    };
  },
  created() {
    this.activeTab = this.tabs[this.activeTabIndex];
  },
  mounted() {
    this.$refs["component-wrapper"].style.height = "350px";
    this.$refs["component-wrapper"].style.width = "400px";
  },
  computed: {
    tabs() {
      return [
        {
          label: this.$t("storeScreen.boxesModal.tabs.boxModal"),
          component: {
            bind: {
              is: BoxModal
            },
            on: {
              refreshData: () => {
                this.$emit("refreshData");
              }
            }
          }
        },
        {
          label: this.$t("storeScreen.boxesModal.tabs.generateBoxes"),
          component: {
            bind: {
              is: GenerateBoxes
            },
            on: {
              refreshData: () => {
                this.$emit("refreshData");
              }
            }
          }
        }
      ];
    }
  },
  methods: {
    changeTab(index) {
      this.activeTabIndex = index;
      this.activeTab = this.tabs[index];
      if (index === 1) {
        this.setModalSizes(350, 250);
      } else {
        this.setModalSizes(400, 350);
      }
    },
    setModalSizes(width, height) {
      this.$refs["component-wrapper"].style.overflow = "hidden";
      this.$anime.timeline().add({
        targets: this.$refs["labels-wrapper"],
        width,
        easing: "easeOutExpo",
        delay: 300
      });
      this.$anime.timeline().add({
        targets: this.$refs["component-wrapper"],
        height,
        width,
        easing: "easeOutExpo",
        delay: 300,
        complete: () => {
          this.$refs["component-wrapper"].style.overflow = "auto";
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#boxes-modal {
  padding-top: 10px;
  .labels-wrapper {
    display: flex;
    justify-content: center;
    padding: 10px;
    .label {
      font-size: 14px;
      cursor: pointer;
      color: inherit;
      transition: 0.3s all ease-in-out;
      width: fit-content;
      text-align: center;
      margin-right: 20px;
      margin-left: 20px;
      &:hover {
        color: $color-light-primary;
      }
      &.active {
        text-decoration: underline;
        font-size: 15px;
        font-weight: bold;
        color: $color-primary;
      }
    }
  }
  .component-wrapper {
    // transition: all 0.5s ease-in;
    // height: 350px;
    // width: 400px;
    max-width: 90vw;
  }
}
</style>
